import ReCaptchaFieldValidator from "../validators/ReCaptchaFieldValidator";
import FormFieldComponent from "./_FormFieldComponent";

export default class ReCaptcha2FormFieldComponent extends FormFieldComponent
{
    field;
    constructor(el) {
        super(el);
        this.field = this.el.querySelector('[data-umb-field-alias]');

        this.validators.push(new ReCaptchaFieldValidator(this.el));
    }

    getValue() {
        return this.field.value;
    }

    getFieldAlias() {
        return 'g-recaptcha-response';
    }
}